import * as ACTION_TYPES from '../types';

let initialState = {
  loading: true,
  dailyStatistics: [],
  weeklyStatistics: [],
  userTasks: [],
  modalTasks: [],
  modalLoading: false,
  financialData: {
    planlananMaliyet: 0,
    toplamGerceklesenMaliyet: 0,
    ekMaliyet: 0,
    gerceklesenMaliyet: 0,
    totalCost: 0,
    profit: 0,
    loss: 0,
    budgetCount: 0,
    profitPercentage: 0
  },
  financialDataLoading: false,
  taskTypeDistribution: [],
  personnelBasedChart: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
      case ACTION_TYPES.GET_DASHBOARD_DAILY_STATISTICS_REQUEST:
        return {...state };
      case ACTION_TYPES.GET_DASHBOARD_DAILY_STATISTICS_SUCCESS:
        return {...state, dailyStatistics: action.payload.data };
      case ACTION_TYPES.GET_DASHBOARD_DAILY_STATISTICS_FAILED:
        return {...state, loading: false };
      case ACTION_TYPES.GET_DASHBOARD_WEEKLY_STATISTICS_REQUEST:
        return {...state };
      case ACTION_TYPES.GET_DASHBOARD_WEEKLY_STATISTICS_SUCCESS:
        return {...state, weeklyStatistics: action.payload.data, loading: false };
      case ACTION_TYPES.GET_DASHBOARD_WEEKLY_STATISTICS_FAILED:
        return {...state, loading: false };
      case ACTION_TYPES.GET_DASHBOARD_USERTASKS_REQUEST:
        return {...state };
      case ACTION_TYPES.GET_DASHBOARD_USERTASKS_SUCCESS:
        return {...state, userTasks: action.payload.data || [] };
      case ACTION_TYPES.GET_DASHBOARD_USERTASKS_FAILED:
        return {...state, loading: false };
      case ACTION_TYPES.GET_DASHBOARD_MODAL_TASKS_REQUEST:
        return {...state, modalLoading: true };
      case ACTION_TYPES.GET_DASHBOARD_MODAL_TASKS_SUCCESS:
        return {...state, modalTasks: action.payload.data, modalLoading: false };
      case ACTION_TYPES.GET_DASHBOARD_MODAL_TASKS_FAILED:
        return {...state, modalLoading: false };
      case ACTION_TYPES.GET_DASHBOARD_FINANCIAL_DATA_REQUEST:
        return {...state, financialDataLoading: true };
      case ACTION_TYPES.GET_DASHBOARD_FINANCIAL_DATA_SUCCESS:
        return {...state, financialData: action.payload.data, financialDataLoading: false };
      case ACTION_TYPES.GET_DASHBOARD_FINANCIAL_DATA_FAILED:
        return {...state, financialDataLoading: false };
      case ACTION_TYPES.GET_TASK_TYPE_DISTRIBUTION_REQUEST:
        return {...state };
      case ACTION_TYPES.GET_TASK_TYPE_DISTRIBUTION_SUCCESS:
        return {...state, taskTypeDistribution: action.payload.data };
      case ACTION_TYPES.GET_TASK_TYPE_DISTRIBUTION_FAILED:
        return {...state };
      case ACTION_TYPES.GET_PERSONNEL_BASED_CHART_REQUEST:
        return {...state };
      case ACTION_TYPES.GET_PERSONNEL_BASED_CHART_SUCCESS:
        return {...state, personnelBasedChart: action.payload.data };
      case ACTION_TYPES.GET_PERSONNEL_BASED_CHART_FAILED:
        return {...state };
      default:
        return state;
    }
  };